import axios from 'axios'
import {getAccessToken} from './msal'
let axiox = axios.create({
  baseURL: 'https://mobiapp.vhu.edu.vn',
  timeout:1000
})

export const setClientToken = function(token){
  axiox.interceptors.request.use(function(config){
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  })
}

axiox.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('Access_Token')
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  error => {
      Promise.reject(error)
  });


axiox.interceptors.response.use((response) => {
  return response
}, function (error) {
  const originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    axiox.defaults.headers.common['Authorization'] = 'Bearer ' + getAccessToken();
    return axiox(originalRequest);
  }
  return Promise.reject(error);
});


export default axiox


// WEBPACK FOOTER //
// ./src/actions/axios.js